<template>
<div class="form-container">
    <form @submit.prevent="buttonClick" >

            <div class="select-container " :class="{'show' : !collapsed}">
                <div class="select " :class="{'show' : !collapsed}">
                    <BirdSelect 
                        :loadBirds="!collapsed"
                        :loadBirdOnSelect="true"
                        height="30px"
                    />
                </div>
            </div>

            <button>
                <svg class="button-symbol  bi bi-search " :class="{'show' : collapsed}" xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" viewBox="0 0 17 17">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                </svg>
                <span class="button-symbol close" :class="{'show' : !collapsed}" style="color: #666;">&#10005;</span>
            </button>


    </form>
</div>
</template>

<script>
import BirdSelect from './BirdSelect.vue';

export default {
    data() {
        return {
            collapsed: true,
        }
    },
    components: {
        BirdSelect,
    },
    methods: {
        buttonClick() {
            if (this.collapsed) {
                this.collapsed = false;
            } 
            else {              
                this.collapsed = true;
            }
        },
    }

}
</script>

<style scoped>
button{
    position: relative;
}
.button-symbol{
    position: absolute;
    opacity: 0;
    transition: opacity 0.1s 0.2s;
    top: 9px;
    left: 10px;
}
.button-symbol.close{
    top: 4px;
    left: 12px;
}
.button-symbol.show{
    opacity: 1;
}

.form-container{
    display: flex;
    justify-content: center;
    align-items: center;
}
form{
    display: flex;
    justify-content: center;
    align-items: center;
}

.select-container{
    position: relative;
    overflow: hidden;
    width: 250px;
    height: 30px;
}
.select-container.show{
    overflow: visible;
    animation: 1s delay-overflow;
}
@keyframes delay-overflow {
  from { overflow: hidden; }
}
.select{
    position: absolute;
    width: 100%;
    height: 100%;
    right: -250px;
    opacity: 0;
    transition: all 0.3s;
}
.select.show{
    right: 0;
    opacity: 1;
}
button{
    width: 30px;
    height: 30px;
    margin-top: -4px;
    border: none;
    background-color: #fff;
    color: #666;
}
@media screen and (max-width: 991px) {
    .button-symbol{
        left: 0px;
    }
    .button-symbol.close{
        left: 0px;
    }

    .form-container{
        display: flex;
        justify-content: left;
        align-items: center;
        padding-top: 1rem;
    }
    form{
        display: flex;
        flex-direction: row-reverse;
    }
    .select{
        right: 250px;

        /* if no search btn 
        right: 0px;
        opacity: 1;*/
    }
    button{     
        margin-left: 0px; /* -4px */
        padding-left: 0px;

        /* if no search btn 
        display: none;*/
    }
}
</style>